import { Trans } from 'react-i18next';
import { generatePath, useNavigate, useLocation, useParams } from 'react-router-dom';

import { Links } from 'settings';
import { isUntaggedCategory } from 'validations';

import { EmptyW, StyledText, UploadButton } from './styled';

export const EmptyState = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { tag, employeeId } = useParams();

  return (
    <EmptyW>
      <StyledText>
        <Trans
          i18nKey={
            isUntaggedCategory(pathname.split('/')[3])
              ? 'document.list.emptyData'
              : 'document.list.emptyData'
          }
        >
          No documents yet. Be the first one to
          {!isUntaggedCategory(pathname.split('/')[3]) ? (
            <UploadButton
              onClick={() => {
                if (!isUntaggedCategory(pathname.split('/')[3])) {
                  if (tag) {
                    navigate(
                      generatePath(Links.resources.createTaggedDocument.tagged.tag, { tag }),
                    );
                  } else if (employeeId) {
                    navigate(
                      generatePath(Links.we.employees.employee.createDocument, { employeeId }),
                    );
                  }
                }
              }}
            >
              upload
            </UploadButton>
          ) : (
            <></>
          )}
          !
        </Trans>
      </StyledText>
    </EmptyW>
  );
};
